export const TEXT_OPTIONS_HEIGHT = '384px';
